module.exports = __webpack_public_path__ + "static/media/badge_level_1_2.0d74c0e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/badges/badge_level_1_2.png
// module id = 500
// module chunks = 0